import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';  
import { MdOutlineDoneOutline } from 'react-icons/md';
import { CiTimer } from 'react-icons/ci';
import { CiDeliveryTruck } from "react-icons/ci";
import { RiRefund2Fill } from "react-icons/ri";
import defaultImage from '../assest/DAWACO_Icon.png'; 

const SalesManViewOrder = () => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const user = useSelector(state => state?.user?.user);  

    useEffect(() => {
        if (id) {
            fetchOrdersByUserId(id);
        }
    }, [id]);

    const fetchOrdersByUserId = async (id) => {
        try {
            setLoading(true);
    
            const apiUrl = user?.type === "Medicine" ? SummaryApi.salesManViewMedicineOrder.url : SummaryApi.salesManViewCosmeticOrder.url;
            const method = user?.type === "Medicine" ? SummaryApi.salesManViewMedicineOrder.method : SummaryApi.salesManViewCosmeticOrder.method;
    
            const response = await fetch(`${apiUrl}/${id}`, {
                method: method,
                credentials: 'include',
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data');
            }
    
            const responseData = await response.json();
            if (responseData.success) {
                const orders = responseData.data; 
                const sortedData = (orders || []).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setData(sortedData || []);
            } else {
                setError(responseData.message || 'Failed to fetch data');
                setData([]);
            }
        } catch (error) {
            setError(error.message || 'Error fetching orders');
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return 'bg-blue-900 text-white';
            case 'pending':
                return 'bg-yellow-600 text-yellow-800';
            case 'rejected':
                return 'bg-red-800 text-white';
            case 'done':
                return 'bg-green-100 text-green-800';
            default:
                return 'bg-gray-700 text-white';
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
            </div>
        );
    }

    return (
        <div className='min-h-[calc(100vh-120px)] flex'>
            <main className='w-full h-full p-4'>
                {error ? (
                    <p className="text-red-500">{error}</p>
                ) : data.length === 0 ? (
                    <p>لا يوجد طلب حاليا</p>
                ) : (
                    data.map((item, index) => (
                        <div key={item._id || index} className="my-4">
                            <p className="font-medium text-lg">{moment(item.createdAt).format('LLL')}</p>
                            <div className="border rounded p-4">
                                <div className="flex flex-col lg:flex-row justify-between">
                                    <div className="grid gap-1">
                                        {item.productDetails?.map((product, index) => (
                                            <div key={product.productId + index} className="flex gap-3 bg-slate-100 p-2">
                                                <img
                                                    src={product?.productImage?.[0] || defaultImage } 
                                                    className="w-28 h-20 bg-slate-200 object-scale-down"
                                                    alt={product?.productName }
                                                />
                                        <div>
                                        <div className="font-medium text-lg text-ellipsis line-clamp-1">{product.productName}</div>
                                        <div className="mt-1">
                                            <div className="text-lg text-blue-800">
                                            {displayINRCurrency(product?.unitPrice)} : سعر المنتج الواحد
                                            </div>
                                            <div className="mt-1">
                                            الكمية : {product?.quantity}
                                            </div>
                                            {product?.bonus >0 &&(
                                            <div className="mt-1">
                                             البونص  : {product?.bonus}
                                            </div>
                                             )}
                                            <div className="mt-1">
                                            {displayINRCurrency(product?.quantity * product?.unitPrice)} : سعر الكمية المطلوبة من هذا المنتج
                                            </div>
                                        </div>
                                        </div>

                                            </div>
                                        ))}
                                    </div>

                                    <div className="font-semibold ml-auto w-fit lg:text-lg">
                                        <div className="flex items-center mb-2 gap-2">
                                            <span className="text-xl font-bold text-blue-800">
                                                {displayINRCurrency(item?.totalPrice || 0)}
                                            </span>
                                            <span className="block mr-2">: المبلغ الاجمالى</span>
                                        </div>



                                        <div className="flex flex-col gap-y-6">
    {/* Status Section */}
    <div className="flex items-center">
        <span className="flex items-center">
            {item?.status === 'pending' ? (
                <>
                    <CiTimer className="inline-block mr-2 text-yello-500 text-2xl" />
                    <span className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-lg font-medium">
                        جاري تحضير الطلب بالمخزن
                    </span>
                </>
            ) : item?.status === 'accepted' ? (
                <>
                    <CiDeliveryTruck className="inline-block mr-2 text-blue-600 text-2xl" />
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-lg text-lg font-medium">
                        تم تحضير الطلب وجاهز للتوصيل
                    </span>
                </>
            ) : item?.status === 'done' ? (
                item?.type === 'order' ?
                <>
                    <MdOutlineDoneOutline className="inline-block mr-2 text-green-500 text-2xl" />
                    <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium">
                        تم ايصال الطلب بنجاح
                    </span>
                </>
                :
                <>
                <RiRefund2Fill className="inline-block mr-2 text-green-500 text-2xl" />
                <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium">
                    طلب استرجاع
                </span>
            </>

            ) : (
                <span className={`px-4 py-2 rounded-lg text-lg font-medium ${getStatusColor(item.status)}`}>
                    {item.status}
                </span>
            )}
        </span>
    </div>
                                    <div className="mb-2 ml-20">
                                            <p className="font-medium text-lg">
                                                <span className="font-semibold text-gray-700">كود الطلب:</span> #{item.orderCode}
                                            </p>
                                        </div>

                                    {/* Order Details Section */}
                                    <div className="mb-4 p-4 border border-gray-200 rounded-lg bg-white shadow-md text-right">
                                    <h2 className="text-xl font-semibold mb-4 text-blue-900 ">معلومات العميل / الصيدلية</h2>


                                        <div className="mb-2">
                                            <p className="font-medium text-lg">
                                                <span className="font-semibold text-gray-500"> الاسم : </span> {item.userName}
                                            </p>
                                        </div>

                                        <div className="mb-2">
                                            <p className="font-medium text-lg">
                                                <span className="font-semibold text-gray-500"> البريد الالكتروني  : </span> {item.email}
                                            </p>
                                        </div>

                                        <div className="mb-2">
                                            <p className="font-medium text-lg">
                                                <span className="font-semibold text-gray-500">عنوان التوصيل  : </span> {item.userShippingAddress}
                                            </p>
                                        </div>
                                        <div className="mb-2">
                                            <p className="font-medium text-lg">
                                                <span className="font-semibold text-gray-500"> رقم الهاتف المحمول : </span> {item.userMobileNumber}
                                            </p>
                                        </div>

                                        <div className="mb-2">
                                            <p className="font-medium text-lg">
                                                <span className="font-semibold text-gray-500">ملحوظات هامة   : </span> {item?.note || 'لا يوجد '}
                                            </p>
                                        </div>

                                       
                                    </div>
                                </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </main>
        </div>
    );
};

export default SalesManViewOrder;
